import React, { useState } from 'react';
import { Menu } from 'primereact/menu';
import { useQueryClient } from '@tanstack/react-query';

import GlobalTooltip from 'components/GlobalTooltip';
import { useMenuIconItems } from 'modules/FileManagerV2/hooks/ui/useMenuIconItems';
import { prefetchDocumentPromotionStatus } from 'modules/FileManagerV2/utils/medicalRecordPromotion';

function MenuIcon({ item, index, itemsRef, onDownloadComplete }) {
  const queryClient = useQueryClient();
  const [, setPromotionMenuRevision] = useState(0);
  const { getItemsOption, deletePermission, firmUserId } = useMenuIconItems({ onDownloadComplete });

  const menuItems = getItemsOption(item)?.filter((menuItem) => menuItem.show && (deletePermission || menuItem.label !== 'Delete'));

  const prefetchPromotionStatus = () => {
    prefetchDocumentPromotionStatus(queryClient, item, firmUserId).then(() => {
      setPromotionMenuRevision((revision) => revision + 1);
    });
  };

  // PrimeReact Menu.toggle(event) must run synchronously on click — deferring after
  // async prefetch leaves a stale event and DomHandler.absolutePosition crashes.
  // Prefetch is click-only (not hover) so scanning a file list never fires one
  // promotion-status request per row passed over.
  const handleMenuToggle = (event) => {
    itemsRef[index]?.current?.toggle(event);
    prefetchPromotionStatus();
  };

  return (
    <>
      <Menu model={menuItems} popup id="popup_menu" ref={itemsRef[index]} />

      <span role="button" onClick={handleMenuToggle}>
        <GlobalTooltip tooltip="More" position="top">
          <i className="icon-more d-inline-block rotate-90 text-primary-main" aria-hidden="true" aria-controls="popup_menu" aria-haspopup />
        </GlobalTooltip>
      </span>
    </>
  );
}

export default MenuIcon;
